<template>
  <div class="bonus-history">

  <HeaderMain
    :hideOrderButton="true"
    title="Информация о начислениях бонусов"
  /> 

  <!-- <div class="header-main ">
    <div class="hm-left ">
      <div>
        <div class="bread-crumb"></div>
        <div class="header-main__title-wrap"><h1 class="header-main__title">Информация о начислениях бонусов</h1>
        <div class="header-main__review"></div>
        </div>
        </div>
      </div>

      <div class="hm-right">
        <div class="btn-wrapper btn-wrapper_group new">
          <router-link to="/tasksto" class="btn_ms m0 btn" v-if="$store.state.user.id === 14">
            <div class="">Задачи</div>
          </router-link>
          <router-link to="/alltask" class="btn_ms m0 btn btntask">
            <div class="">Задачи</div>
          </router-link>
          <router-link to="/orders" class="btn_ms btn">
            <div class="">Заказы</div>
          </router-link>
        <router-link to="/" class="btn_ms btn">
            <div class="">Товары</div>
          </router-link>             
        </div>
      </div>

    </div> -->

    <div class="filters">
      <div class="filter-group">
        <label for="filter_created_at">Дата операции:</label>
        <div class="input_flex">
          <date-picker
            v-model="filters.from"
            format="YYYY-MM-DD"
            input-class="mx-input"
            :placeholder="'От'"
            id="filter_created_at_gte"
            class="mx-datepicker"
          />
          <span> - </span>
          <date-picker
            v-model="filters.to"
            format="YYYY-MM-DD"
            input-class="mx-input"
            :placeholder="'До'"
            id="filter_created_at_lte"
            class="mx-datepicker"
          />
        </div>
      </div>

      <div class="filter-group">
        <label for="filter_phone">Телефон:</label>
        <input
          type="text"
          id="filter_phone"
          class="input"
          v-model="filters.phone"
          placeholder="Телефон"
        />
      </div>

      <div class="filter-group">
        <label for="filter_order_id">ID заказа:</label>
        <input
          type="text"
          id="filter_order_id"
          class="input"
          v-model="filters.order_id"
          placeholder="ID заказа"
        />
      </div>

      <div class="filter-group">
        <label for="filter_action">Статус:</label>
        <select
          id="filter_action"
          class="input"
          v-model="filters.action"
        >
          <option value="">Все статусы</option>
          <option value="accrual">Начисление</option>
          <option value="reserve">Резерв</option>
          <option value="spend">Списание</option>
          <option value="return">Возврат</option>
        </select>
      </div>

      <div class="filter-group">
        <button @click="fetchHistory" class="btn">Поиск</button>
        <button @click="clearFilters" class="btn btn-clear">Сбросить</button>
      </div>
    </div>

    <div class="table-wrapper">
      <LoaderTable v-if="loading" />
      <table v-else class="history-table">
        <thead>
          <tr>
            <th>Дата</th>
            <th>Телефон</th>
            <th>ID заказа</th>
            <th>Сумма</th>
            <th>Действие</th>
            <th>Бонус/Резерв до</th>
            <th>Бонус/Резерв после</th>
            <th>Описание</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in history" :key="row.id">
            <td>{{ formatDate(row.created_at) }}</td>
            <td>{{ row.phone }}</td>
            <td>{{ row.order_id }}</td>
            <td :class="getAmountClass(row.amount)">
              {{ row.amount > 0 ? '' : '' }}{{ row.amount }}
            </td>
            <td>
              <span :class="['status', row.action]">{{ getActionLabel(row.action) }}</span>
            </td>
            <td>
              <!-- Бонусы и резервы ДО -->
              <div> {{ row.bonus_before || 0 }} /  {{ row.reserve_before || 0 }}</div>
             
            </td>
            <td>
              <!-- Бонусы и резервы ПОСЛЕ -->
              <div> {{ row.bonus_after || 0 }} / {{ row.reserve_after || 0 }}</div>
              
            </td>
            <td>{{ row.description }}</td>
          </tr>
          <tr v-if="!history.length && !loading">
            <td colspan="8" class="empty-row">Нет данных</td>
          </tr>
        </tbody>

      </table>
    </div>

    
      <b-pagination
  v-if="totalPages > 1"
  v-model="page"
  :per-page="limit"
  :total-rows="total"
  @change="handlePageChange"
></b-pagination>
   
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import LoaderTable from '@/components/LoaderTable.vue'
import HeaderMain from '@/components/HeaderMain.vue'
import axios from 'axios';
export default {
  components: { DatePicker, LoaderTable, HeaderMain },
  data() {
    return {
      filters: {
        phone: '',
        order_id: '',
        action: '',
        from: null, // дата "от"
        to: null,   // дата "до"
      },
      history: [],
      loading: false,
      page: 1,
      limit: 100,
      total: 0,
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.limit) || 1
    },
  },
  methods: {
    fetchHistory() {
        this.loading = true
        const params = {
          ...this.filters,
          limit: this.limit,
          page: this.page,
        }
        if (!this.filters.from) delete params.from
        if (!this.filters.to) delete params.to

        axios
          .get('/bonus-history', { params })
          .then(res => {
            this.history = res.data.history
            this.total = res.data.total || 0
          })
          .catch(() => {
            this.history = []
          })
          .finally(() => {
            this.loading = false
          })
      },
      handlePageChange(newPage) {
        this.page = newPage
        this.fetchHistory()
      },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      return d.toLocaleString('ru-RU')
    },
    getAmountClass(amount) {
      return amount > 0 ? 'plus' : amount < 0 ? 'minus' : ''
    },
    getActionLabel(action) {
      switch (action) {
        case 'accrual': return 'Начисление'
        case 'reserve': return 'Резерв'
        case 'spend':   return 'Списание'
        case 'return':  return 'Возврат'
        default:        return action
      }
    },
    changePage(p) {
      this.page = p
      this.fetchHistory()
    },
    clearFilters() {
      this.filters = { phone: '', order_id: '', action: '', from: null, to: null }
      this.page = 1
      this.fetchHistory()
    }
  },
  mounted() {
    this.fetchHistory()
  },
  watch: {
    limit() {
      this.page = 1
      this.fetchHistory()
    },
  }
}
</script>


<style scoped>
.bonus-history {
  max-width: 1200px;
  margin: 0 auto;
}
.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 18px;
  margin-top: 0px;
  background: #fff;
  padding: 20px;
}
.input {
  min-width: 160px;
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: #fff;
  font-size: 15px;
}
.btn {
  padding: 7px 16px;
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
  margin-right: 10px;
}
.btn-clear {
  background: #e5e7eb;
  color: #111827;
}
.table-wrapper {
  min-height: 160px;
  position: relative;
}
.history-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
  background: #fff;
}
.history-table th, .history-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #f1f5f9;
  text-align: left;
}
.history-table th {
  background: #f9fafb;
  font-weight: 600;
}
.empty-row {
  color: #aaa;
  text-align: center;
  font-style: italic;
}
.plus { color: #059669; font-weight: 600; }
.minus { color: #ef4444; font-weight: 600; }
.status {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
  text-transform: capitalize;
}
.status.accrual { background: #e0f2fe; color: #0369a1; }
.status.reserve { background: #fef9c3; color: #b45309; }
.status.spend   { background: #fee2e2; color: #b91c1c; }
.status.return  { background: #dcfce7; color: #15803d; }
.pagination {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 18px 0 0;
  justify-content: center;
}
.pagination button {
  padding: 5px 13px;
  border: none;
  background: #e5e7eb;
  color: #374151;
  border-radius: 4px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  transition: background 0.15s;
}
.pagination button:disabled {
  opacity: 0.4;
  cursor: default;
}

.input, select.input {
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 15px;
  height: 36px!important;          /* фиксированная высота */
  background: #fff;
  appearance: none;      /* убирает стандартные стрелки, если нужно */
  box-sizing: border-box;
   vertical-align: middle;
  margin: 0;
}

select.input {
  /* Для кроссбраузерности */
  line-height: normal;

  /* appearance: none;  если нужна кастомная стрелка, оставь, иначе можно убрать */
}


.header-main {
    display: flex;
    empty-cells: hide;
    padding: 0px 0 24px;
    justify-content: space-between;
}

.header-main .hm-left,
.header-main .hm-right {
    display: table-cell;
    float: none;
    vertical-align: top;
}
.hm-left h1 {
    font-size: 24px;
    font-weight: 500;
    letter-spacing: -.3px;
    line-height: 32px;
    margin-top: 10px;
  }


  .btn_ms { 
    margin-right: 15px;
    background: linear-gradient(180deg, #fea530, #e48e1e) !important;
    color: #ffffff;
    font-size: 16px;
    height: 25px;
    line-height: 24px;
    padding: 12px 24px;
  }


.history-table > thead tr th {
  background: #f9fafb;
}
.history-table th {
    color: #636f7f;
    cursor: default;
    font-size: 11px;
    font-weight: 400;
    height: 41px;
    line-height: 12px;
    padding-bottom: 5px;
    padding-top: 6px;
}

.history-table td {
    font-size: 11px;
    vertical-align: middle;
    }
</style>
